import GonCampaignAccessor from '../../common/helper/gon_campaign_accessor.js';

/**
 * 完了ページへのリンクボタンの初期化
 *
 * `[data-gampla-component="finish-link-btn"]` 要素を対象に、
 * `gon.campaign.finish_link_button`（GonCampaignAccessor 経由）を読み取り
 * 表示制御とクリック時の遷移先設定を行う。
 *
 * 表示判定はサーバー側（CampaignGonable#set_gon_finish_link_button）で完結しており、
 * ここでは `visible` の値をそのまま使う。
 *
 * 表示制御は gampla-entry-btn と同様、CSS側でデフォルト非表示にした上で
 * 条件成立時のみ `data-finish-link-visible` 属性を付与する方式（_finish-link-btn.css）。
 * gon出力漏れ・JS未実行時にも非表示側へフェイルセーフする。
 */
export default function initFinishLinkButtons() {
  const elements = document.querySelectorAll('[data-gampla-component="finish-link-btn"]');
  elements.forEach(setupFinishLinkButton);
}

function setupFinishLinkButton(element) {
  const finishLinkButton = new GonCampaignAccessor().finishLinkButton;

  // gon データがない = モジュールテンプレートのeditor-canvas内など。何もしない。
  // エディタ canvas 内での表示は grapes.js の canvasCss（display:none の打ち消し）で担保する。
  if (!finishLinkButton) return;

  if (!finishLinkButton.visible) return;

  const redirectUrl = finishLinkButton.redirect_url;
  element.setAttribute('data-finish-link-visible', 'true');
  element.setAttribute('role', 'button');
  element.setAttribute('tabindex', '0');

  const activate = () => {
    if (redirectUrl) {
      window.location.href = redirectUrl;
    }
  };

  element.addEventListener('click', activate);
  // WCAG 2.1.1: role="button" + tabindex="0" を付与しているため、
  // Enter / Space キーでも起動できるようにする（'Spacebar' は旧ブラウザ互換）
  element.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
      event.preventDefault();
      activate();
    }
  });
}
